import script from "./F0009.vue?vue&type=script&lang=ts&setup=true"
export * from "./F0009.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__